import { css } from "styled-components";

const mainText1 = css`
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: -0.017em;
  text-align: center;
`;

const mainText2 = css`
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.017em;
  text-align: center;
`;

const popupText = css`
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.03em;
  text-align: center;
`;

const buttonText1 = css`
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.017em;
  text-align: center;
`;

const buttonText2 = css`
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.017em;
  text-align: center;
`;

const typography = {
  mainText1,
  mainText2,
  popupText,
  buttonText1,
  buttonText2,
};

export default typography;
